export default String.raw`
.dialog {
    width: 100%;
    margin: auto 0 0 0;
    max-width: 100%;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;

    &.middle {
        width: fit-content;
        margin: auto;
        max-width: none;
        border-radius: 10px;
    }
}

body:has(dialog[open]) {
    overflow: hidden;
}

.technical-break {
    margin: 48px 32px 0 32px;
    flex-direction: column;
    gap: 32px;

    .content {
        display: flex;
        gap: 32px;
        align-items: center;
        margin-bottom: 32px;

        &__info {
            margin: 0;
            text-align: center;
            max-width: 520px;
        }

        img {
            align-items: center;
        }

        &__mobile {
            display: block;
            width: 400px;
            height: 400px;
        }
    }

    &__image {
        display: none;
    } 
}

.cookie-message-opener {
    bottom: 20px;
    left: 10px;
}

.cookie-container-background {
    align-items: flex-end;
}

.cookie-container {
    max-width: none;
    border-radius: 12px 12px 0 0;
}

.customer-container-menu {
    > ul {
        border: none;
    }
}
`